
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import ModalHeader from "@/components/modal-header.vue";
import ModalTitle from "@/lib/model/exam/modal-title";
import {
  CandidateCreateOne,
  CandidateFeatures,
  CandidateItem
} from "@/lib/model/exambuilder/exam-component/candidate";
import { ExamSmallItem } from "@/lib/model/exambuilder/exam-component/exam-list";
import { ExamComponent } from "@/lib/model/exambuilder/exam-component/exam";
import Reg from "@/lib/common/Reg";

@Component({
  components: {
    ModalHeader
  }
})
export default class AddOneCandidateModal extends Vue {
  @Prop() candidateCreateForm!: CandidateCreateOne;
  @Prop() private examName!: string;
  @Prop() private isVisible!: boolean;
  @Prop() private paperId!: number;
  @Prop() private examAll!: ExamSmallItem[];

  async mounted() {
    await this.getTagList();
    this.isVisibleTag = this.isVisible;
    this.modalTitle.title = "添加一位候选人";
    this.modalTitle.hasDesc = true;
    this.modalTitle.desc = this.examName;
    this.candidateCreateForm.sendMessage = 1;

    if (this.paperId > 0) {
      this.candidateCreateForm.examId = this.paperId;
      this.canSelected = false;
      this.checkEmail();
    }
  }

  // 弹窗
  isVisibleTag = false;
  modalTitle = new ModalTitle();
  rules = {
    phone: [
      { required: true, message: "请输入手机号", trigger: "blur" },
      {
        validator: (rule: unknown, value: string, callback: Function) => {
          if (!Reg.isMobile(value)) {
            return callback(new Error("手机号格式校验失败"));
          } else {
            return callback();
          }
        },
        trigger: ["blur"]
      }
    ]
  };

  @Emit("on-close-one")
  handleClose() {
    this.candidateCreateForm.tags = [];
  }

  @Emit("on-add-cancel")
  addCancel() {
    this.candidateCreateForm.tags = [];
    this.isVisibleTag = false;
  }

  showSelectError = false;
  showNameError = false;
  showMobileError = false;

  checkNameVal(name: string) {
    this.showNameError = !name;
  }

  checkMobileVal(mobile: number) {
    this.showMobileError = !mobile;
  }

  checkParams() {
    let checkFlag = true;

    if (!this.candidateCreateForm.examId) {
      this.showSelectError = true;
      checkFlag = false;
    }

    if (!this.candidateCreateForm.showName) {
      this.showNameError = true;
      checkFlag = false;
    }

    if (!this.candidateCreateForm.phone) {
      this.showMobileError = true;
      checkFlag = false;
    }

    return checkFlag;
  }

  addSubmit(continueAdd = false) {
    const checkRes = this.checkParams();

    if (!checkRes) return;

    this.candidateCreateForm.loginId = this.candidateCreateForm.phone;

    CandidateItem.create(this.candidateCreateForm).then(res => {
      if (res.code === 0) {
        this.$message.success("添加成功");
        this.onSuccessStatus();

        if (continueAdd) {
          this.candidateCreateForm.showName = "";
          this.candidateCreateForm.phone = "";
          this.candidateCreateForm.email = "";
          this.candidateCreateForm.tags = [];
        } else {
          this.addCancel();
        }
      } else {
        this.$message.error("添加失败，已存在相同手机号的候选人正在答题");
      }
    });
  }

  @Emit("on-success-status")
  onSuccessStatus() {
    return true;
  }

  // 面试
  canSelected = true;
  hasEmail = false; // 是否有邮箱字段

  examSelect() {
    this.showSelectError = false;
    this.checkEmail();
  }

  checkEmail() {
    if (!this.candidateCreateForm.examId) {
      return (this.hasEmail = false);
    }

    ExamComponent.hasEmail(this.candidateCreateForm.examId).then(res => {
      if (res.code !== 0) return;

      this.hasEmail = res.data.hasEmail;
    });
  }

  // 标签
  tagList: readonly string[] = [];
  filterTagList: readonly string[] = [];
  searching = false;

  async getTagList() {
    const res = await CandidateFeatures.get();
    this.tagList = Object.freeze(res.tag.filter(item => !!item));
    this.filterTagList = [...this.tagList.slice(0, 100)];
  }

  // 性能优化：最多展示前100条，或者搜索结果  --客户电脑配置低
  filterTag(query?: string) {
    if (this.searching) return;

    this.searching = true;

    if (!query) {
      this.filterTagList = [...this.tagList.slice(0, 100)];

      this.$nextTick(() => {
        this.searching = false;
      });

      return;
    }

    const res = this.tagList.filter((item: string) => {
      return item.indexOf(query) > -1;
    });

    this.filterTagList = res.slice(0, 100);

    this.$nextTick(() => {
      this.searching = false;
    });
  }

  // 搜索失焦后 空结果重置
  checkTagList() {
    this.filterTag();
  }
}
